module.exports = __webpack_public_path__ + "media/images/about-pic2-f98f94d1.png";